import _ from 'lodash';
import { getActionTypes } from '../../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('TaskAttribute')([
  'SET_LOADER',
  'UPSERT_ATTRIBUTE',
  'DELETE_ATTRIBUTE',
  'LOAD_ALL_ATTRIBUTES',
]);

export function loadGlobalAttributes(attributes) {
  return { type: types.LOAD_ALL_ATTRIBUTES, attributes };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function deleteAttribute(attribute) {
  return { type: types.DELETE_ATTRIBUTE, attributeId: attribute.id };
}

export function upsertAttribute(attribute) {
  return { type: types.UPSERT_ATTRIBUTE, attribute };
}

export default function globalAttributeReducer(state = { isLoading: true, attributes: [] }, action) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isLoading: action.loader };
    }
    case types.LOAD_ALL_ATTRIBUTES: {
      return { ...state, attributes: action.attributes };
    }
    case types.DELETE_ATTRIBUTE: {
      return {
        ...state,
        attributes: state.attributes.filter(({ id }) => id !== action.attributeId),
      };
    }
    case types.UPSERT_ATTRIBUTE: {
      const { attribute } = action;
      return {
        ...state,
        attributes: [...state.attributes.filter(({ id }) => id !== attribute.id), attribute],
      };
    }
    default:
      return state;
  }
}

export const getAllGlobalTaskAttributesSelector = (state) => {
  const globalAttributes = _.get(state, 'globalAttributeReducer.attributes') || [];
  return globalAttributes.filter((attr) => attr.entityType === 'task');
};

export const getAllVendorAttributesSelector = (state) => {
  const globalAttributes = _.get(state, 'globalAttributeReducer.attributes') || [];
  return globalAttributes.filter((attr) => attr.entityType === 'vendor');
};

export const getAllAssetAttributesSelector = (state) => {
  const globalAttributes = _.get(state, 'globalAttributeReducer.attributes') || [];
  return globalAttributes.filter((attr) => attr.entityType === 'asset');
};
